<template>
  <draggable
    :list="motive.children"
    item-key="name"
    @change="changeDrag($event, group.id, result.id, motive.id)"
  >
    <template #item="{ element, index }">
      <TypificationItem
        :key="index"
        :index="index"
        :item="element"
        :parent="motive"
        :name="`Submotivo ${index + 1}`"
        :total="totalSubmotives"
        type="submotive"
        @updateTree="updateTree"
        @onToggleStatus="
          handleToggleStatus(
            $event,
            element,
            `Submotivo ${index + 1}`,
            group.id,
            result.id,
            motive.id,
            element.id
          )
        "
      >
        <template #edit="{ hideMoreOptions }">
          <TypificationForm
            :item="element"
            :disabled="haveForm(result, motive)"
            @onChange="handleChange($event, element)"
            @updateTree="updateTree"
            @click="hideMoreOptions"
          />

          <SubmotiveEdit
            :item="element"
            :itemmotive="motive"
            :itemgroup="group"
            :itemresult="result"
            @change="handleChange($event, element)"
            @click="hideMoreOptions"
          />

          <a-button
            type="text"
            @click="
              handleDeleteItem(
                $event,
                element,
                `Submotivo ${index + 1}`,
                group.id,
                result.id,
                motive.id,
                element.id
              );
              hideMoreOptions();
            "
          >
            <template #icon>
              <DeleteOutlined />
            </template>

            Eliminar submotivo
          </a-button>
        </template>
      </TypificationItem>
    </template>
  </draggable>
</template>

<script>
import TypificationItem from "@/app/entities/components/picker/TypificationItem.vue";
import { defineComponent } from "vue";
import { DeleteOutlined } from "@ant-design/icons-vue";
import SubmotiveEdit from "@/app/entities/components/drawers/typifications/TypificationSubmotiveEdit.vue";
import TypificationForm from "@/app/entities/components/modals/typifications/TypificationForm.vue";
import draggable from "vuedraggable";
export default defineComponent({
  components: {
    DeleteOutlined,
    TypificationItem,
    SubmotiveEdit,
    draggable,
    TypificationForm,
  },
  props: {
    motive: {
      required: true,
      type: Object,
    },
    result: {
      required: true,
      type: Object,
    },
    group: {
      required: true,
      type: Object,
    },
  },
  computed: {
    totalSubmotives() {
      return this.motive.children.length;
    },
  },
  methods: {
    changeDrag($event, ...args) {
      this.$emit("onDrag", $event, ...args);
    },
    handleChange(newItem, oldItem) {
      this.$emit("onChange", newItem, oldItem);
    },
    handleDeleteItem(...args) {
      this.$emit("onDelete", ...args);
    },
    handleToggleStatus(...args) {
      this.$emit("onToggleStatus", ...args);
    },
    updateTree() {
      this.$emit("updateTree");
    },
    haveForm(result, motive) {
      if (result.form_id != null) return true;
      if (motive.form_id != null) return true;
      return false;
    },
  },
});
</script>

<style></style>
